export default "__VITE_ASSET__Cz$VIMQ___"